// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"9952816f","453":"a23ba594","952":"26cc0a30"}[chunkId] + ".chunk.js";
};